var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { buildMarginsProps } from '../../helpers/builders';
export var Link = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration-color: ", ";\n\n  ", ";\n"], ["\n  text-decoration-color: ", ";\n\n  ", ";\n"])), function (_a) {
    var theme = _a.theme, textDecorationColor = _a.textDecorationColor;
    return textDecorationColor !== null && textDecorationColor !== void 0 ? textDecorationColor : theme.brand.color.status.neutral1;
}, buildMarginsProps);
var templateObject_1;
